import React, { forwardRef } from 'react';

import { Box, FormControlLabel, Grid, Switch, Typography } from '@mui/material';

import { SwitchBox } from './MuiSwitch.style';

import type { SwitchProps } from '@mui/material';

export type MuiSwitchProps = {
  isDisabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  label?: string;
  labelLeft?: string;
  labelRight?: string;
  color?: 'primary' | 'secondary';
  isContainTwoLabel?: boolean;
  secondLabel?: string;
} & Partial<SwitchProps>;

export const MuiSwitch = forwardRef<HTMLHeadingElement, MuiSwitchProps>((props, ref) => {
  const { isDisabled, onChange, checked, color, label, labelLeft, labelRight, isContainTwoLabel, ...args } =
    props;

  return isContainTwoLabel ? (
    <Box>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item>
          <Typography>{labelLeft} </Typography>
        </Grid>
        <Grid item>
          <SwitchBox {...args} checked={checked} disabled={isDisabled} onChange={onChange} />
        </Grid>
        <Grid item>
          <Typography>{labelRight} </Typography>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <FormControlLabel
      ref={ref}
      color={color}
      control={<Switch {...args} checked={checked} disabled={isDisabled} onChange={onChange} />}
      label={label}
    />
  );
});
